<template>
    <v-card flat class="pa-2">
        <v-layout row align-center class="pb-1">
            <v-flex shrink>
                <span class="caption greyType--text">Import History</span>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex shrink>
                <v-btn small flat icon color="primary" class="ma-0 pa-0" :disabled="loading" @click="$emit('refresh')">
                    <v-icon small>refresh</v-icon>
                </v-btn>
            </v-flex>
        </v-layout>

        <v-data-table
                :headers="tableHeaders"
                :items="runs"
                item-key="id"
                class="elevation-1 compact-table"
                :loading="loading"
                :rows-per-page-items="[10, 25, 50, {text: 'All', value: -1}]"
        >
            <template slot="items" slot-scope="props">
                <tr style="cursor: pointer" @click="$emit('select', props.item)">
                    <td class="text-xs-right" style="width: 80px">{{ props.item.id }}</td>
                    <td>{{ props.item.description }}</td>
                    <td>
                        <v-chip small :color="statusColor(props.item.status)" text-color="white">
                            {{ props.item.status }}
                        </v-chip>
                    </td>
                    <td class="text-xs-right">{{ props.item.row_count }}</td>
                    <td>{{ formatDate(props.item.created_at) }}</td>
                    <td>{{ formatDate(props.item.finished_at) }}</td>
                    <td>{{ props.item.source_filename }}</td>
                </tr>
            </template>
            <template slot="no-data">
                <div class="text-xs-center pa-2">
                    <span class="body-1 greyType--text">No import runs yet</span>
                </div>
            </template>
        </v-data-table>

        <div class="pt-1">
            <span class="caption greyType--text">Click a run to resume it, watch its progress, or open its report</span>
        </div>
    </v-card>
</template>

<script>

    import {codeBaseMixin} from "../../codeBaseMixin";

    export default {
        mixins: [codeBaseMixin],
        props: {
            runs: {
                type: Array,
                default: () => []
            },
            loading: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                tableHeaders: [
                    {text: 'ID', value: 'id', align: 'right'},
                    {text: 'Description', value: 'description'},
                    {text: 'Status', value: 'status'},
                    {text: 'Rows', value: 'row_count', align: 'right'},
                    {text: 'Created', value: 'created_at'},
                    {text: 'Finished', value: 'finished_at'},
                    {text: 'Source File', value: 'source_filename'}
                ]
            }
        },
        methods: {
            statusColor(status) {
                switch (status) {
                    case 'draft':
                        return 'grey';
                    case 'previewed':
                        return 'blue-grey';
                    case 'running':
                        return 'blue';
                    case 'completed':
                        return 'green';
                    case 'completed_with_errors':
                        return 'orange';
                    case 'failed':
                        return 'red';
                    case 'cancelled':
                        return 'blue-grey';
                    default:
                        return 'grey';
                }
            },
            formatDate(value) {
                if (value == null || value == '') {
                    return '';
                }
                return String(value).replace('T', ' ').substring(0, 16);
            }
        }
    }
</script>

<style scoped>
    .compact-table >>> td, .compact-table >>> th {
        padding: 0 8px !important;
        height: 32px !important;
    }
</style>
